import { Link } from "react-router-dom";
import {useEffect, useState} from 'react';
import Breadcrumb from "../Components/Breadcrumb";
import August2022 from '../assets/PDF/IQAC/August2022.pdf';
import December2022 from '../assets/PDF/IQAC/December2022.pdf';
import { Initiatives } from "../Data/GovernanceData";

const sidemenus = [
    {
    title: "Internal Quality Assurance Committee",
    url: "/IQACCell/InternalQualityAssuranceCommittee",
  },
];

export default function IQACCell(props){
    const [menuName, setName] = useState(props.pageName);
    const [menuId, setId] = useState(props.pageId);

    useEffect(() => {
        setName(props.pageName);
        setId(props.pageId);
    }, [props.pageName, props.pageId]);

    useEffect(() => {
        // Remove active-menu class from all links first
        const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));
        allWithClass.forEach((element) => {
            element.classList.remove("active-menu");
        });

        let id = menuId.toString();
        let currentEl = document.getElementById(id);
        if (currentEl) {
            currentEl.setAttribute('class', 'active-menu');
        }

        // Add d-none class for all divs
        sidemenus.forEach(element => {
            let id = element.title.split(' ').join('').toString();
            let div = document.getElementById(id);
            if (div) div.classList.add('d-none');
        });

        // remove class d-none of particular div on click by getting Id
        let divId = menuName.split(' ').join('').toString();
        let activeDiv = document.getElementById(divId);
        if (activeDiv) activeDiv.classList.remove('d-none');

        // scroll top
        window.scrollTo(0, 0);
    }, [menuName, menuId]);

    const handleClick = event => {
        setName(event.currentTarget.textContent);
        setId(event.currentTarget.id);

        // Remove all class active-menu of '.sideMenu a' on click
        const allWithClass = Array.from(
            document.querySelectorAll(".sideMenu a")
        );

        allWithClass.forEach((element) => {
            element.classList.remove("active-menu");
        });

    };

    return(
        <>
            <Breadcrumb pageTitle={menuName} />
            <div className="container mt-3">
                <div className="row default-padding-bottom">
                    {/* Sidebar */}
                    <aside className="sideMenu col-lg-3">
                        <div className="scroll-div">
                            {sidemenus.map((menu,index)=>{
                                return(
                                    <Link key={index} id={index} onClick={handleClick} to={menu.url}> {menu.title} </Link>
                                );
                            })}
                        </div>
                    </aside>
                    {/* content */}
                    <div className="col-lg-9">
                        <div className="px-lg-3 px-1">
                            {sidemenus.map((menu,index)=>{
                                return(
                                   <div id={menu.title.split(' ').join('').toString()} key={index}>
                                        {props.pageContent}
                                   </div>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export function InternalQualityAssurance() {
  return (
    <div>
      <h5 className="title-text mb-2">Internal Quality Assurance Committee</h5>
      <Initiatives />
    </div>
  );
}